import formMixin from './mixins/form.js';
import Way2Forms from './components/way2forms.js';
import Way2Form from './plugins/Way2Form.js';

export { formMixin, Way2Forms, Way2Form };
